import { useState } from 'react';
import { OnboardingEye } from '../Eye';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from '../step1/OnboardingSequence';
import InputBar from '../InputBar';
import BPInput from '../../BionicUI/input/BPInput';
// import { PostUserProfileRequest } from 'core/models/users/profile/post-user-profile.model';
// import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
// import { useAuth } from 'context/auth.context';
// import { usePrivy } from '@privy-io/react-auth';
import useOnboardingProjectStore from 'stores/onboardingProjectStore';
import { isValidUrl } from 'utils/validation';
import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';

const Video = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const { nextStep, setProgressStep, setProjectInfo, projectInfo } =
    useOnboardingProjectStore();

  async function handleSubmit(inputText: string | null | undefined) {
    if (!inputText) return;
    setProjectInfo('projectVideoUrl', inputText);
    nextStep();
  }

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'If you have a video, or a link to a page on Virtuals, enter that below.',
            sound: 'projectStep/if-you-have-video-or-virtuals-link.mp3',
          }}
          onAnimComplete={() => setShowInputBar(true)}
        />
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => setProgressStep(5)}>
          <BPInput
            value={
              projectInfo?.projectVideoUrl ? projectInfo.projectVideoUrl : ''
            }
            state="default"
            type="text"
            placeholder="Enter project video link"
            button={{
              state: 'primary',
              onClick: (e, inputText) => handleSubmit(inputText),
              title: 'Submit',
            }}
            validate={(text) => {
              const passed = isValidUrl(text);
              return passed;
            }}
          />
          <BPLinkButton onClick={nextStep}>Skip</BPLinkButton>
        </InputBar>
      )}
    </SequenceItem>
  );
};

export default Video;
